import LinkButton from '../LinkButton.ui';

export const getLinkButton = (to: string, label: string): JSX.Element => {
  return <LinkButton linkProps={{ to }}>{label}</LinkButton>;
};
